import React, { useCallback } from 'react';
import {
  Card, Spinner, Alert,
} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import { uint8array } from '../../../containers/services/SignKey/auth/oldSign';
import useEU from '../../../ciatEU/hook';
import Signer from '../../../containers/services/SignKey/auth/signer';

function LoginFormKEP({
  ecpGet,
  ecpPost,
  onLogin,
  onRequirePassword,
  stringToSign,
  requestId,
  isWideMode,
}) {
  const {
    readkeyFile, initialized, cert, signData, onClearKey, loading, setLoading, err, setErr,
    libraryType, setLibraryType, keyMedias, readKeyMedia, selectedKM, setSelectedKM,
    issuers, issuer, setIssuer, needCertificate, certificates, setCertificates,
  } = useEU();

  const authenticate = useCallback(() => {
    const sign = async ({ stringToSign: strToSign, requestId: reqId }) => {
      const str = uint8array(strToSign, 'utf16le');
      const signed = await signData(str, true);
      return { requestId: reqId, signed };
    };

    setErr(null);
    setLoading(true);

    const getStringAndRequestId = ecpGet
      ? ecpGet()
      : Promise.resolve({ stringToSign, requestId });

    getStringAndRequestId
      // eslint-disable-next-line max-len
      .then(({ stringToSign: strToSign, requestId: reqId }) => sign({ stringToSign: strToSign, requestId: reqId }))
      .then(({ requestId: reqId, signed }) => ecpPost({ requestId: reqId, signed }))
      .then((result) => {
        if (result.next_step) {
          onRequirePassword();
        } else if (result.access && result.refresh) {
          onLogin(result.access, result.refresh);
        } else {
          throw new Error('Некоректна відповідь сервера');
        }
      })
      .catch((e) => setErr({ type: 'error', message: e.message }))
      .finally(() => setLoading(false));
  }, [
    ecpGet,
    ecpPost,
    onRequirePassword,
    onLogin,
    signData,
    setErr,
    setLoading,
    stringToSign,
    requestId,
  ]);

  return (
    <Card className="p-1 mt-3 shadow-sm">
      <Card.Body>
        <Card.Title className="mb-4 d-flex align-items-center">
          <FontAwesomeIcon icon={faLock} className="me-2" />
          Авторизація за допомогою КЕП
        </Card.Title>

        {err && <Alert variant="danger">{err.message}</Alert>}

        <Signer
          isWideMode={isWideMode}
          submitTitle="Авторизуватись"
          loading={loading}
          err={err}
          initialized={initialized}
          onReadKeyFile={readkeyFile}
          onReadKeyMedia={readKeyMedia}
          cert={cert}
          onSubmit={authenticate}
          onReset={onClearKey}
          libraryType={libraryType}
          onSetLibraryType={setLibraryType}
          keyMedias={keyMedias}
          selectedKM={selectedKM}
          setSelectedKM={setSelectedKM}
          issuers={issuers}
          issuer={issuer}
          setIssuer={setIssuer}
          needCertificate={needCertificate}
          certificates={certificates}
          setCertificates={setCertificates}
          size="sm"
        />

        {loading && (
          <div className="text-center mt-3">
            <Spinner animation="border" size="sm" />
          </div>
        )}
      </Card.Body>
    </Card>
  );
}

LoginFormKEP.propTypes = {
  ecpGet: PropTypes.func,
  ecpPost: PropTypes.func.isRequired,
  onLogin: PropTypes.func.isRequired,
  onRequirePassword: PropTypes.func.isRequired,
  stringToSign: PropTypes.string,
  requestId: PropTypes.string,
  isWideMode: PropTypes.bool.isRequired,
};

LoginFormKEP.defaultProps = {
  ecpGet: null,
  stringToSign: null,
  requestId: null,
};

export default LoginFormKEP;
